(function() {
  var SEC_PER_DAY = 86400;

  function parseJSONSafe(value) {
    if (!value) return null;
    try {
      return typeof value === 'string' ? JSON.parse(value) : value;
    } catch (err) {
      return null;
    }
  }

  function toNumber(val) {
    var num = parseInt(val, 10);
    return isNaN(num) ? 0 : num;
  }

  function escapeHtml(value) {
    return (value || '').toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeRegion(region) {
    var val = (region || '').toString().toUpperCase();
    if (val === 'US' || val === 'USA' || val === 'UNITED STATES') return 'US';
    if (val === 'CA' || val === 'CANADA') return 'CA';
    return val || 'BOTH';
  }

  function bumpWeekend(ts) {
    var date = new Date(ts * 1000);
    var dow = date.getDay();

    if (dow === 6) {
      date.setDate(date.getDate() + 2);
    } else if (dow === 0) {
      date.setDate(date.getDate() + 1);
    }

    return Math.floor(date.getTime() / 1000);
  }

  function countBusinessDaysBetween(startTs, endTs) {
    var startDate = new Date((startTs || Date.now() / 1000) * 1000);
    var endDate = new Date((endTs || startTs || Date.now() / 1000) * 1000);

    startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

    if (endDate <= startDate) return 0;

    var businessDays = 0;
    var cursor = new Date(startDate);

    while (cursor < endDate) {
      cursor.setDate(cursor.getDate() + 1);
      var dow = cursor.getDay();
      if (dow !== 0 && dow !== 6) {
        businessDays += 1;
      }
    }

    return businessDays;
  }

  function extractField(obj, key) {
    if (!obj) return undefined;
    if (typeof obj[key] !== 'undefined') return obj[key];
    if (obj.value && typeof obj.value[key] !== 'undefined') return obj.value[key];
    if (obj.fields && obj.fields[key]) {
      var f = obj.fields[key];
      if (typeof f.value !== 'undefined') return f.value;
      if (typeof f.reference !== 'undefined') return f.reference;
    }
    return undefined;
  }

  function computeDisplayDate(daysFromToday, startTs) {
    return computeBusinessDisplayDate(daysFromToday, startTs);
  }

  function computeBusinessDisplayDate(businessDaysFromToday, startTs) {
    var date = new Date((startTs || Date.now() / 1000) * 1000);
    var daysAdded = 0;
    var targetBusinessDays = Math.max(0, businessDaysFromToday);

    while (daysAdded < targetBusinessDays) {
      date.setDate(date.getDate() + 1);
      var dow = date.getDay();
      if (dow !== 0 && dow !== 6) {
        daysAdded += 1;
      }
    }

    return bumpWeekend(Math.floor(date.getTime() / 1000));
  }

  function buildInventoryMap(raw, variantId) {
    var parsed = parseJSONSafe(raw) || {};
    var source = parsed && parsed.value ? parsed.value : parsed;

    if (!source || typeof source !== 'object') return {};

    var locations = source.locations;
    if (locations && typeof locations === 'object') return locations;

    var variantKey = typeof variantId === 'undefined' || variantId === null ? null : variantId.toString();
    var variants = source.variants;
    if (variants && typeof variants === 'object' && variantKey) {
      var variantEntry = variants[variantKey] || variants[variantId];
      var variantLocations = variantEntry && (variantEntry.locations || variantEntry);
      if (variantLocations && typeof variantLocations === 'object') return variantLocations;
    }

    var productLocations = source.productLocations;
    if (productLocations && typeof productLocations === 'object') return productLocations;

    return {};
  }

  function selectWarehouses(config) {
  var inventoryByLocation = buildInventoryMap(config.inventoryMap, config.inventoryVariantId);
  var candidates = [];
  var market = config.market === 'US' ? 'US' : 'CA';
  var sources = Array.isArray(config.fulfillmentSources)
    ? config.fulfillmentSources
    : [];

  // --- DEBUG STEP 1: what are we working with? ---
  console.log('[ETA][WH] inventoryByLocation:', inventoryByLocation, 'raw:', config.inventoryMap, 'variantId:', config.inventoryVariantId);
  console.log('[ETA][WH] market:', market);
  console.log('[ETA][WH] fulfillmentSources count:', sources.length);
  // -----------------------------------------------

  sources.forEach(function(source, idx) {
    if (!source) return;
    var enabled = extractField(source, 'enabled');
    if (!(enabled === true || enabled === 1 || enabled === '1' || enabled === 'true')) return;

    var region = normalizeRegion(extractField(source, 'region_visibility'));
    if (!(region === 'BOTH' || region === market)) return;

    var locationId = extractField(source, 'shopify_location_id');
    if (!locationId) return;

    var qty = toNumber(inventoryByLocation[locationId] || 0);
    if (qty <= 0) return;

    var displayAsStore = extractField(source, 'display_as_store');
    var storeLink = extractField(source, 'store_link');
    var fixedDays = toNumber(extractField(source, 'fixed_shipping_days'));
    var bufferDays = toNumber(extractField(source, 'buffer_days'));
    var maxDisplayQty = extractField(source, 'max_display_quantity');
    var combineSameEta = extractField(source, 'combine_quantity_when_same_eta');
    var sourceName = extractField(source, 'name') || extractField(source, 'key') || 'Warehouse';
    var sourceIdentifier = [
      extractField(source, 'key'),
      extractField(source, 'handle'),
      extractField(source, 'internal_key'),
      sourceName,
      locationId
    ].join('|').toLowerCase();
    var isManufacturerInventorySource =
      sourceIdentifier.indexOf('manufacturer-inventory') !== -1 ||
      sourceIdentifier.indexOf('manufacturer inventory') !== -1 ||
      sourceIdentifier.indexOf('ford-racing-inventory') !== -1 ||
      sourceIdentifier.indexOf('ford racing inventory') !== -1 ||
      sourceIdentifier.indexOf('116224393579') !== -1;
    var isExternalWarehouseSource =
      sourceIdentifier.indexOf('wheelpros-us') !== -1 ||
      sourceIdentifier.indexOf('wheelpros us') !== -1 ||
      sourceIdentifier.indexOf('wheelpros_us') !== -1 ||
      sourceIdentifier.indexOf('115961135467') !== -1;

    var etaDays = fixedDays + bufferDays;
    var etaTs = computeDisplayDate(etaDays, config.todayTs);
    candidates.push({
      idx: idx,
      etaDays: etaDays,
      etaTs: etaTs,
      qty: qty,
      name: sourceName,
      maxDisplayQty: typeof maxDisplayQty === 'number' ? maxDisplayQty : toNumber(maxDisplayQty),
      combineSameEta: combineSameEta === true || combineSameEta === 'true' || combineSameEta === 1 || combineSameEta === '1',
      displayAsStore: displayAsStore === true || displayAsStore === 'true' || displayAsStore === 1 || displayAsStore === '1',
      storeLink: storeLink,
      isManufacturerInventorySource: isManufacturerInventorySource,
      isExternalWarehouseSource: isExternalWarehouseSource
    });
  });

  // --- DEBUG STEP 1: did we get any candidates at all? ---
  console.log('[ETA][WH] candidates after filtering:', candidates);
  // -------------------------------------------------------

  if (!candidates.length) return null;

  candidates.sort(function(a, b) {
    if (a.etaDays === b.etaDays) return a.idx - b.idx;
    return a.etaDays - b.etaDays;
  });

  var best = candidates[0];
  var combinedQty = best.qty;
  if (best.combineSameEta) {
    candidates.forEach(function(entry, i) {
      if (i === 0) return;
      if (entry.etaTs === best.etaTs) {
        combinedQty += entry.qty;
      }
    });
  }

  var qtyToShow = best.maxDisplayQty ? Math.min(combinedQty, best.maxDisplayQty) : combinedQty;
  var displayDate = new Date(best.etaTs * 1000).toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
  });

  // --- DEBUG STEP 1: who won? ---
  console.log('[ETA][WH] winner:', {
    name: best.name,
    qty: best.qty,
    combinedQty: combinedQty,
    qtyToShow: qtyToShow,
    etaDays: best.etaDays,
    displayDate: displayDate
  });
  // -------------------------------

  return {
    path: 'warehouse',
    qtyToShow: qtyToShow,
    displayDate: displayDate,
    etaDays: best.etaDays,
    displayAsStore: best.displayAsStore,
    storeLink: best.storeLink,
    isManufacturerInventorySource: best.isManufacturerInventorySource,
    isExternalWarehouseSource: best.isExternalWarehouseSource,
    best: best,
    candidates: candidates,
    debug: {
      market: market,
      inventoryByLocation: inventoryByLocation,
      candidates: candidates,
      winner: {
        name: best.name,
        etaDays: best.etaDays,
        etaTs: best.etaTs,
        qty: best.qty,
        qtyToShow: qtyToShow,
        displayDate: displayDate,
        displayAsStore: best.displayAsStore,
        storeLink: best.storeLink,
        isManufacturerInventorySource: best.isManufacturerInventorySource,
        isExternalWarehouseSource: best.isExternalWarehouseSource
      },
      rules: [
        'Only enabled fulfillment sources are considered.',
        'Region visibility must include the current market (' + market + ').',
        'Location must have on-hand quantity.',
        'Lowest ETA wins. If combine_same_eta is true, quantities with matching ETA are combined.'
      ]
    }
  };
}


  function computeTurn14(config) {
    var etaObj = config.turn14 || {};
    var availList = Array.isArray(etaObj.availability) ? etaObj.availability : [];
    if (!availList.length) return null;

    var todayTs = (config.todayTs || Date.now() / 1000);
    var today = new Date(todayTs * 1000);
    var todayStartTs = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime() / 1000;
    var marketIsUS = config.market === 'US';

    var buffers = Array.isArray(config.warehouseBuffers) ? config.warehouseBuffers : [];
    function getBuffer(state) {
      if (marketIsUS) return { base: 0, buf: 0 };
      var match = buffers.find(function(b) {
        return b && extractField(b, 'enabled') && extractField(b, 'warehouse_state_code') === state;
      });
      return match
        ? {
            base: toNumber(extractField(match, 'fixed_shipping_days')),
            buf: toNumber(extractField(match, 'buffer_days'))
          }
        : { base: 0, buf: 0 };
    }

    var best = null;
    var anyStock = availList.some(function(entry) {
      if (!entry) return false;
      return toNumber(entry.Quantity || entry.qty) > 0;
    });
    var anyEta = false;
    var hasPastEta = false;
    var hasFutureEta = false;
    var manufacturerStock = toNumber(
      etaObj.manufacturerStock ||
      etaObj.ManufacturerStock ||
      etaObj.manufacturer_stock
    );
    var manufacturerEstimatedShipDate =
      etaObj.manufacturerEstimatedShipDate ||
      etaObj.ManufacturerEstimatedShipDate ||
      etaObj.manufacturerEsd ||
      etaObj.ManufacturerEsd ||
      etaObj.manufacturer_esd ||
      null;
    var manufacturerStockShippingDays = toNumber(config.manufacturerStockShippingDays);
    if (manufacturerStockShippingDays <= 0) manufacturerStockShippingDays = 5;
    var manufacturerBest = null;

    availList.forEach(function(entry) {
      if (!entry) return;
      var qty = toNumber(entry.Quantity || entry.qty);

      // If any source has inventory, only evaluate in-stock sources.
      // This prevents zero-quantity sources from winning the ETA ranking
      // when an in-stock source exists.
      if (anyStock && qty <= 0) return;

      var etaTsRaw = null;
      var etaIsPast = false;
      if (entry.EstimatedShipDate) {
        etaTsRaw = Date.parse(entry.EstimatedShipDate + 'T00:00:00Z') / 1000;
        if (!isNaN(etaTsRaw)) {
          anyEta = true;
          if (etaTsRaw < todayStartTs) {
            hasPastEta = true;
            etaIsPast = true;
          } else {
            hasFutureEta = true;
          }
        }
      }

      var baseBusinessDays = null;
      if (qty > 0) {
        baseBusinessDays = 1;
      } else if (etaTsRaw && !etaIsPast) {
        baseBusinessDays = countBusinessDaysBetween(todayTs, etaTsRaw);
      }

      if (baseBusinessDays !== null) {
        var totalDays = baseBusinessDays;
        if (marketIsUS) {
          totalDays += qty > 0 ? toNumber(config.usInStockBuffer) : toNumber(config.usOutOfStockBuffer);
        } else {
          var buf = getBuffer(entry.LocationState);
          totalDays += buf.base + buf.buf;
        }
        var displayTs = computeBusinessDisplayDate(totalDays, todayTs);

        if (!best || totalDays < best.totalDays) {
          best = {
            totalDays: totalDays,
            qty: qty,
            displayDate: new Date(displayTs * 1000).toLocaleDateString('en-US', {
              month: 'short',
              day: '2-digit',
              year: 'numeric'
            })
          };
        }
      }
    });

    if (!anyStock && manufacturerStock > 0) {
      var manufacturerTotalDays = manufacturerStockShippingDays;
      var manufacturerDisplayTs = computeBusinessDisplayDate(manufacturerTotalDays, todayTs);
      manufacturerBest = {
        totalDays: manufacturerTotalDays,
        qty: manufacturerStock,
        shipDays: manufacturerStockShippingDays,
        source: 'manufacturer',
        manufacturerEstimatedShipDate: manufacturerEstimatedShipDate,
        displayDate: new Date(manufacturerDisplayTs * 1000).toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })
      };

      best = manufacturerBest;
    }

    var treatAsNoConfirmedEta = !anyStock && manufacturerStock <= 0 && anyEta && hasPastEta && !hasFutureEta;
    return {
      path: 'turn14',
      best: best,
      treatAsNoConfirmedEta: treatAsNoConfirmedEta,
      anyStock: anyStock,
      manufacturerStock: manufacturerStock,
      debug: {
        market: marketIsUS ? 'US' : 'CA',
        availabilityEntries: availList,
        best: best,
        anyStock: anyStock,
        manufacturerStock: manufacturerStock,
        manufacturerEstimatedShipDate: manufacturerEstimatedShipDate,
        manufacturerStockShippingDays: manufacturerStockShippingDays,
        manufacturerBest: manufacturerBest,
        anyEta: anyEta,
        hasPastEta: hasPastEta,
        hasFutureEta: hasFutureEta,
        treatAsNoConfirmedEta: treatAsNoConfirmedEta,
        bufferRules: marketIsUS
          ? 'US market uses usInStockBuffer/usOutOfStockBuffer.'
          : 'CA market uses per-warehouse state buffers when ETA is present.'
      }
    };
  }

  function computeVendorFallback(config) {
    var vendorName = (config.vendor || '').toString();
    if (!vendorName) return null;

    function norm(str) {
      return (str || '').toString().trim().toLowerCase();
    }

    var groups = Array.isArray(config.vendorGroups) ? config.vendorGroups : [];
    var assignments = Array.isArray(config.vendorAssignments) ? config.vendorAssignments : [];

    var assignment = assignments.find(function(entry) {
      return entry && norm(extractField(entry, 'vendor_name')) === norm(vendorName);
    });

    function resolveGroupKey(ref) {
      if (!ref) return null;

      var direct = [
        extractField(ref, 'id'),
        extractField(ref, 'gid'),
        extractField(ref, 'key'),
        extractField(ref, 'handle'),
        extractField(ref, 'internal_key')
      ].find(function(val) { return !!val; });
      if (direct) return direct;

      if (ref.reference) {
        var viaReference = resolveGroupKey(ref.reference);
        if (viaReference) return viaReference;
      }

      if (ref.metaobject) {
        var viaMetaobject = resolveGroupKey(ref.metaobject);
        if (viaMetaobject) return viaMetaobject;
      }

      if (ref.value && ref.value !== ref) {
        return resolveGroupKey(ref.value);
      }

      return ref;
    }

    var groupKey = assignment ? resolveGroupKey(extractField(assignment, 'eta_group')) : null;
    var groupEta = assignment ? extractField(assignment, 'group_eta') : null;

    var normAssignmentKeys = [groupKey, groupEta]
      .map(norm)
      .filter(function(val) { return !!val; });

    var group = groups.find(function(entry) {
      var candidates = [
        extractField(entry, 'id'),
        extractField(entry, 'gid'),
        extractField(entry, 'key'),
        extractField(entry, 'internal_key'),
        extractField(entry, 'handle'),
        extractField(entry, 'name')
      ].map(norm);
      return normAssignmentKeys.some(function(assignmentKey) {
        return candidates.some(function(val) { return val && val === assignmentKey; });
      });
    });

    if (!group) return null;

    var behavior = extractField(group, 'behavior');
    var title = extractField(group, 'static_message_title');
    var body = extractField(group, 'static_message_body');
    var checkboxLabel = extractField(group, 'checkbox_label');

    if (body && typeof body === 'object') {
      if (typeof body.value !== 'undefined') {
        body = body.value;
      } else if (typeof body.body !== 'undefined') {
        body = body.body;
      }
    }

    if (checkboxLabel && typeof checkboxLabel === 'object') {
      if (typeof checkboxLabel.value !== 'undefined') {
        checkboxLabel = checkboxLabel.value;
      } else if (typeof checkboxLabel.text !== 'undefined') {
        checkboxLabel = checkboxLabel.text;
      }
    }

    if ((behavior || '').toLowerCase() === 'dynamic eta' || (behavior || '').toLowerCase() === 'dynamic') {
      var etaDays = toNumber(extractField(group, 'fixed_business_days')) + toNumber(extractField(group, 'buffer_days'));
      var etaTs = computeBusinessDisplayDate(etaDays, config.todayTs);
      var displayDate = new Date(etaTs * 1000).toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric'
      });
      return {
        path: 'vendor-dynamic',
        badgeState: 'special',
        displayDate: displayDate,
        etaDays: etaDays,
        noteValue: 'Yes — Special order, ETA ' + displayDate,
        ackText: checkboxLabel || null,
        message: badgeHtml('special', 'Special order', 'i') + 'Typically ships in about ' + etaDays + ' business days.<br>Estimated ship date: <strong>' + displayDate + '</strong>',
        debug: {
          vendor: vendorName,
          assignmentKey: groupKey || groupEta,
          behavior: behavior,
          bufferDays: toNumber(extractField(group, 'buffer_days')),
          fixedDays: toNumber(extractField(group, 'fixed_business_days')),
          messageTitle: title,
          messageBody: body,
          assignmentRaw: assignment,
          groupRaw: group,
          mode: 'dynamic'
        }
      };
    }

    var vendorStaticText = ((title || '') + ' ' + (body || '')).toLowerCase();
    var isMadeToOrder = vendorStaticText.indexOf('made to order') !== -1 || vendorStaticText.indexOf('made-to-order') !== -1;
    return {
      path: 'vendor-static',
      badgeState: isMadeToOrder ? 'madetoorder' : 'special',
      madeToOrder: isMadeToOrder,
      noteValue: isMadeToOrder ? 'Yes — Made to order, no ETA' : 'Yes — Special order, no ETA',
      title: title || 'Special Order',
      body: body || 'Special order item with no confirmed ETA. Contact sales@raptorracing.com for info.',
      ackText: isMadeToOrder ? 'I understand this item is made to order with no confirmed ETA and cannot be cancelled once ordered.' : (checkboxLabel || null),
      debug: {
        vendor: vendorName,
        assignmentKey: groupKey || groupEta,
        behavior: behavior,
        messageTitle: title,
        messageBody: body,
        assignmentRaw: assignment,
        groupRaw: group,
        mode: 'static'
      }
    };
  }

  function badgeHtml(state, label, icon) {
    return '<div class="eta-badge eta-badge--' + state + '"><span class="eta-badge__icon" aria-hidden="true">' + icon + '</span><span>' + label + '</span></div>';
  }

  function compute(config) {
    var todayTs = config.todayTs || Date.now() / 1000;
    var baseConfig = Object.assign({}, config, { todayTs: todayTs });
    var isCanadaMarket = config.market === 'CA';
    var defaultAckText = 'I understand the estimated shipping time is an approximation and may change.';
    var canadaAckText = 'I understand the estimated ship / pickup date is an approximation and may change.';
    var manufacturerUsAckText = 'I understand the estimated shipping date is an approximation and may change.';
    var warehousePickupNotice = '<strong>No same-day pickup available.</strong></div><div class="eta-block">Ships or ready for pickup approx. ';

    var vendorAttempt = computeVendorFallback({
      vendor: config.vendor,
      vendorGroups: config.vendorGroups,
      vendorAssignments: config.vendorAssignments,
      todayTs: todayTs
    });

    var warehouseResult = selectWarehouses({
      market: config.market,
      inventoryMap: config.inventoryMap,
      inventoryVariantId: config.inventoryVariantId,
      fulfillmentSources: config.fulfillmentSources,
      todayTs: todayTs
    });

    var turn14Result = computeTurn14({
      turn14: config.turn14,
      warehouseBuffers: config.warehouseBuffers,
      usInStockBuffer: config.usInStockBuffer,
      usOutOfStockBuffer: config.usOutOfStockBuffer,
      manufacturerStockShippingDays: config.manufacturerStockShippingDays,
      market: config.market,
      todayTs: todayTs
    });
    var turn14HasAvailableStock = turn14Result &&
      turn14Result.best &&
      !turn14Result.treatAsNoConfirmedEta &&
      turn14Result.best.qty > 0;
    var useTurn14OverWarehouse = warehouseResult &&
      turn14HasAvailableStock &&
      turn14Result.best.totalDays < warehouseResult.etaDays;

    if (warehouseResult && !useTurn14OverWarehouse) {
      var warehouseDebug = {
        warehouse: warehouseResult.debug,
        turn14: turn14Result && turn14Result.debug,
        vendor: vendorAttempt && vendorAttempt.debug,
        finalPath: 'warehouse'
      };
      var storeText = warehouseResult.isExternalWarehouseSource ? 'external warehouse' : 'warehouse';
      if (warehouseResult.displayAsStore) {
        storeText = warehouseResult.storeLink
          ? '<a href="' + warehouseResult.storeLink + '" target="_blank" rel="noopener">store</a>'
          : 'store';
      }
      var whBadgeState = warehouseResult.isManufacturerInventorySource ? 'manufacturer' : (warehouseResult.displayAsStore ? 'local' : 'warehouse');
      var whBadge = whBadgeState === 'local'
        ? badgeHtml('local', 'In stock locally', '&#10003;')
        : whBadgeState === 'manufacturer'
          ? badgeHtml('manufacturer', 'Manufacturer stock', '&#10003;')
          : badgeHtml('warehouse', 'Warehouse stock', '&#10003;');
      var warehouseMessage = whBadge + '<b>' + warehouseResult.qtyToShow + '</b> available in our ' + storeText + '.<div class="eta-block">Ships approx. <strong>' + warehouseResult.displayDate + '</strong></div>';

      if (warehouseResult.isManufacturerInventorySource) {
        warehouseDebug.finalPath = 'manufacturer-inventory';
        var manufacturerInventoryVendorName = (config.vendor || 'the manufacturer').toString().trim() || 'the manufacturer';
        var manufacturerInventoryQtyText = '<b>' + warehouseResult.qtyToShow + '</b> available at <b>' + escapeHtml(manufacturerInventoryVendorName) + '</b><br>';
        warehouseMessage = isCanadaMarket
          ? whBadge + manufacturerInventoryQtyText + '<div class="eta-block">Ships from Mississauga or pickup approx. <strong>' + warehouseResult.displayDate + '</strong></div>'
          : whBadge + manufacturerInventoryQtyText + '<div class="eta-block">Ships direct from manufacturer by approx. <strong>' + warehouseResult.displayDate + '</strong></div>';
      } else if (isCanadaMarket) {
        if (warehouseResult.displayAsStore) {
          warehouseMessage = badgeHtml('local', 'In stock locally', '&#10003;') + '<b>' + warehouseResult.qtyToShow + '</b> in our ' + storeText + '.<div class="eta-block"><strong>Same Day Pickup</strong>, or ships approx. <strong>' + warehouseResult.displayDate + '</strong></div>';
        } else {
          warehouseMessage = whBadge + '<b>' + warehouseResult.qtyToShow + '</b> available in our ' + storeText + '.<div class="eta-block">' + warehousePickupNotice + '<strong>' + warehouseResult.displayDate + '</strong></div>';
        }
      }

      return {
        path: warehouseResult.isManufacturerInventorySource ? 'manufacturer-inventory' : 'warehouse',
        badgeState: whBadgeState,
        qtyToShow: warehouseResult.qtyToShow,
        displayDate: warehouseResult.displayDate,
        noteValue: 'Yes — ' + (whBadgeState === 'local' ? 'In stock locally' : (whBadgeState === 'manufacturer' ? 'Manufacturer stock' : 'Warehouse stock')) + ', ETA ' + warehouseResult.displayDate,
        ackText: warehouseResult.isManufacturerInventorySource && !isCanadaMarket ? manufacturerUsAckText : (isCanadaMarket ? canadaAckText : defaultAckText),
        message: warehouseMessage,
        debug: warehouseDebug
      };
    }

    if (turn14Result && turn14Result.best && !turn14Result.treatAsNoConfirmedEta) {
      var turn14Debug = {
        warehouse: warehouseResult && warehouseResult.debug,
        turn14: turn14Result.debug,
        vendor: vendorAttempt && vendorAttempt.debug,
        finalPath: turn14Result.best.source === 'manufacturer' ? 'turn14-manufacturer' : 'turn14'
      };
      var isManufacturerStock = turn14Result.best.source === 'manufacturer';
      var isOutOfStock = !(turn14Result.best.qty > 0);
      var qtyText = badgeHtml('oos', 'Out of stock', '!');
      if (!isOutOfStock && isManufacturerStock) {
        var manufacturerVendorName = (config.vendor || 'the manufacturer').toString().trim() || 'the manufacturer';
        qtyText = badgeHtml('manufacturer', 'Manufacturer stock', '&#10003;') + '<b>' + turn14Result.best.qty + '</b> available at <b>' + escapeHtml(manufacturerVendorName) + '</b><br>';
      } else if (!isOutOfStock) {
        qtyText = badgeHtml('warehouse', 'Warehouse stock', '&#10003;') + '<b>' + Math.min(turn14Result.best.qty, 10) + '</b> in our external warehouse.<br>';
      }
      var message = isOutOfStock
        ? qtyText + '<div class="eta-block">Restock approx. <strong>' + turn14Result.best.displayDate + '</strong><br>Order now to reserve yours.</div>'
        : isManufacturerStock && isCanadaMarket
          ? qtyText + '<div class="eta-block">Ships from Mississauga or pickup approx. <strong>' + turn14Result.best.displayDate + '</strong></div>'
          : isManufacturerStock
            ? qtyText + '<div class="eta-block">Ships direct from manufacturer by approx. <strong>' + turn14Result.best.displayDate + '</strong></div>'
          : qtyText + '<div class="eta-block">Ships approx. <strong>' + turn14Result.best.displayDate + '</strong></div>';
      if (isCanadaMarket && !isOutOfStock && !isManufacturerStock) {
        message = qtyText + '<div class="eta-block">' + warehousePickupNotice + '<strong>' + turn14Result.best.displayDate + '</strong></div>';
      }
      var turn14NoteValue = isOutOfStock
        ? 'Yes — Out of stock, restock ETA ' + turn14Result.best.displayDate
        : (isManufacturerStock
            ? 'Yes — Manufacturer stock, ETA ' + turn14Result.best.displayDate
            : 'Yes — Warehouse stock, ETA ' + turn14Result.best.displayDate);
      return {
        path: 'turn14',
        badgeState: isOutOfStock ? 'oos' : (isManufacturerStock ? 'manufacturer' : 'warehouse'),
        displayDate: turn14Result.best.displayDate,
        noteValue: turn14NoteValue,
        ackText: isOutOfStock
          ? 'I understand this item is <strong>out of stock</strong> and the restock date may change.'
          : (isManufacturerStock && !isCanadaMarket ? manufacturerUsAckText : (isCanadaMarket ? canadaAckText : defaultAckText)),
        message: message,
        debug: turn14Debug
      };
    }

    var vendorResult = vendorAttempt;

    if (vendorResult) {
      var vendorDebug = {
        warehouse: warehouseResult && warehouseResult.debug,
        turn14: turn14Result && turn14Result.debug,
        vendor: vendorResult.debug,
        finalPath: vendorResult.path
      };
      if (vendorResult.path === 'vendor-dynamic') {
        return Object.assign({}, vendorResult, {
          ackText: vendorResult.ackText || 'I understand the estimated shipping time is an approximation and may change.',
          debug: vendorDebug
        });
      }
      return Object.assign({}, vendorResult, {
        isSpecialOrder: true,
        ackText: vendorResult.ackText || 'I understand this is a <strong>special order</strong> with no confirmed ETA.',
        debug: vendorDebug
      });
    }

    var hasTurn14Partnumber = config.turn14 && (config.turn14.partnumber || config.turn14.partNumber || config.turn14.part_number);
    var unknownMessage = badgeHtml('special', 'Special order', 'i') + 'No confirmed ETA — contact <a href="mailto:sales@raptorracing.com">sales@raptorracing.com</a>';
    return {
      path: 'unknown',
      badgeState: 'special',
      noteValue: 'Yes — Special order, no ETA',
      ackText: 'I understand this is a special order with no confirmed ETA.',
      message: unknownMessage,
      debug: {
        warehouse: warehouseResult && warehouseResult.debug,
        turn14: turn14Result && turn14Result.debug,
        vendor: vendorAttempt && vendorAttempt.debug,
        finalPath: 'unknown'
      }
    };
  }

  window.RaptorEta = {
    compute: compute,
    helpers: {
      parseJSONSafe: parseJSONSafe,
      toNumber: toNumber,
      bumpWeekend: bumpWeekend,
      countBusinessDaysBetween: countBusinessDaysBetween,
      computeDisplayDate: computeDisplayDate,
      computeBusinessDisplayDate: computeBusinessDisplayDate
    }
  };
})();
